import { z } from 'zod'

export const unreadNotificationSchema = z.object({
  id: z.string(),
  type: z.string(),
  title: z.string(),
  message: z.string(),
  createdAt: z.string()
})

export type UnreadNotification = z.infer<typeof unreadNotificationSchema>

export const unreadNotificationsResponseSchema = z.object({
  notifications: z.array(unreadNotificationSchema)
})

export type UnreadNotificationsResponse = z.infer<typeof unreadNotificationsResponseSchema>
